import React from 'react'

const Nutrition_You_Can_Trust = () => {
  return (
    <>
      <section className="cta-strip-premium" style={{marginTop:"10px"}}>
        <div className="cta-inner">
          <div className="cta-divider"></div>
          <h2>Nutrition You Can Trust</h2>
          <p>
            Clean, lab-tested protein crafted for strength, recovery, and consistent performance.
          </p>
          <a
            href="/bestsellers"  // Changed to point to bestsellers page
            className="pro-acc-logout-btn mt-sm-4 mt-2 btn-md text-white fw-bold"
          >
            View Bestsellers
          </a>

          <div className="cta-trust-line">Lab Tested • FSSAI Approved • GMP Certified</div>
        </div>
      </section>
    </>
  )
}

export default Nutrition_You_Can_Trust